import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { locatorOf, toPointer } from '../../core/issues.js';

/** A gameshow never uses a swipe deck, on any node. */
export const swipeSelectBanned: Rule<Gameshow> = {
  code: 'gameshow.activity.swipeSelect',
  check(input): ValidationIssue[] {
    return input.nodes.flatMap((node, nodeIdx): ValidationIssue[] => {
      if (node.activity?.type !== 'swipe_select') {
        return [];
      }
      const path: (string | number)[] = ['nodes', nodeIdx, 'activity', 'type'];
      return [{
        code: 'gameshow.activity.swipeSelect.banned',
        severity: 'error',
        message: `Node ${node.id}: a gameshow never uses swipe_select. Ask this round as multiple choice, phrase matching, drag pairing or drag ordering.`,
        path,
        pointer: toPointer(path),
        locator: locatorOf({ nodeId: node.id }),
        currentValue: 'swipe_select',
        constraint: { kind: 'enum', detail: 'a gameshow activity is never swipe_select' },
      }];
    });
  },
};
